import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

import LoadingSpinner from './LoadingSpinner';
import { showSuccess, showError } from '../utils/toastHelper';

const AuthComplete = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setToken } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (token) {
      // Token'ı kaydet ve ana sayfaya yönlendir
      localStorage.setItem('auth_token', token);
      setToken(token);
      showSuccess('Hesabınız başarıyla oluşturuldu!');
      navigate('/products', { replace: true });
    } else {
      showError('Bir hata oluştu. Lütfen tekrar deneyin.');
      navigate('/login', { replace: true });
    }
  }, [searchParams, navigate, setToken]);

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <LoadingSpinner message="Hesabınız oluşturuluyor..." size="medium" />
    </div>
  );
};

export default AuthComplete; 